import { RootState } from 'store'

export const isVisible = (state: RootState) => state.spinner.visible
